import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { ModalController, MenuController, ActionSheetController } from '@ionic/angular';

import { environment } from '../environments/environment.prod';

import { SplashScreen } from '@capacitor/splash-screen';
import { Preferences } from '@capacitor/preferences';

import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { AuthenticationService } from './services/authentication.service';
import { ConfigService } from './services/config.service';
import { ConsoleToggleService } from './services/console-toggle.service';

import { HistoryHelperService } from './utils/history-helper.service';

import { AboutPage } from './about/about.page';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    './side-menu/styles/side-menu.scss',
    './side-menu/styles/side-menu.shell.scss',
    './side-menu/styles/side-menu.responsive.scss'
  ]
})
export class AppComponent {
  appPages = [
    {
      title: 'Dashboard',
      url: '/app/dashboard',
      ionicIcon: 'grid-outline'
    },
    {
      title: 'Visits',
      url: '/app/visit',
      ionicIcon: 'list-outline'
    },
    // {
    //   title: 'Profile',
    //   url: '/app/user',
    //   ionicIcon: 'person-outline'
    // },
    // {
    //   title: 'Contact Card',
    //   url: '/contact-card',
    //   customIcon: './assets/custom-icons/side-menu/contact-card.svg'
    // },
    // {
    //   title: 'Notifications',
    //   url: '/app/notifications',
    //   ionicIcon: 'notifications-outline'
    // }
  ];

  accountPages = [
    // {
    //   title: 'Log In',
    //   url: '/auth/login',
    //   ionicIcon: 'log-in-outline',
    // },
    {
      title: 'Logout',
      url: '/auth/login',
      ionicIcon: 'log-out-outline'
    },
    // {
    //   title: 'Sign Up',
    //   url: '/auth/signup',
    //   ionicIcon: 'person-add-outline'
    // },
    // {
    //   title: 'Getting Started',
    //   url: '/getting-started',
    //   ionicIcon: 'rocket-outline'
    // },
    // {
    //   title: '404 page',
    //   url: '/page-not-found',
    //   ionicIcon: 'alert-circle-outline'
    // }
  ];

  textDir = 'ltr';

  config: any = null;

  version: string = environment.version || '0.0.0';
  build: string = environment.build || 'build';

  // Inject HistoryHelperService in the app.components.ts so its available app-wide
  constructor(
    private swUpdate: SwUpdate,
    private modalController: ModalController,
    private menuCtrl: MenuController,
    private actionSheetCtrl: ActionSheetController,
    private translate: TranslateService,
    private historyHelper: HistoryHelperService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private consoleToggleService: ConsoleToggleService
  ) {
    // if (this.swUpdate.isEnabled) {
    //   if (this.swUpdate.available) {
    //     this.swUpdate.available.subscribe(() => {
    //       if (confirm(this.translate.instant('APP.MESSAGE.UPDATE.APP_UPDATE_AVAILABLE'))) {
    //         window.location.reload();
    //       }
    //     });
    //   }
    // }

    this.consoleToggleService.disableConsoleInProduction();

    this.config = this.configService.getConfiguration();
    this.authenticationService.setConfig(this.config);

    this.initializeApp();
    this.setLanguage();
    this.showWalkthrough();
  }

  async initializeApp() {
    try {
      await SplashScreen.hide();
    } catch (err) {
      console.log('This is normal in a browser', err);
    }
  }

  async showWalkthrough() {
    const { value } = await Preferences.get({ key: 'visitedWalkthrough' });
    if (!value) {
      this.router.navigateByUrl('walkthrough');
    }
  }

  public setLanguage(): void {
    const defaultLanguage = this.translate.getBrowserLang() || this.config.AppConfig.DefaultLanguage;
    let language = localStorage.getItem('language');
    if (!language) {
      localStorage.setItem('language', defaultLanguage);
    }
    this.translate.setDefaultLang(language);

    this.translate.use(language);

    // this is to determine the text direction depending on the selected language
    // for the purpose of this example we determine that only arabic and hebrew are RTL.
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   this.textDir = (event.lang === 'ar' || event.lang === 'iw') ? 'rtl' : 'ltr';
    // });
  }

  public openTutorial(): void {
    // save key to mark the walkthrough as NOT visited because the user wants to check it out
    Preferences.set({
      key: 'visitedWalkthrough',
      value: 'false'
    });
    this.router.navigateByUrl('walkthrough');
  }

  isLoggedIn(): boolean {
    return this.authenticationService.isLogged();
  }

  async openAbout() {
    const modal = await this.modalController.create({
      component: AboutPage,
      componentProps: { isDialog: true }
    });
    return await modal.present();
  }

  reloadApp() {
    window.location.reload();
  }

  selectLanguage() {
    const languages = this.config.AppConfig.Languages || [];
    const actionSheet = this.actionSheetCtrl.create({
      header: this.translate.instant('APP.TITLE.SelectLanguage'),
      buttons: languages.map((language: any) => ({
        text: this.translate.instant(`APP.LANGUAGE.${language.language}`),
        handler: () => {
          this.translate.use(language.alpha2Code);
          localStorage.setItem('language', language.alpha2Code);
        }
      }))
    });
    actionSheet.then((res) => {
      res.present();
    });
  }
}
